import React from 'react';
import { 
    Card,
    Image,
    Text,
    Group,
    Badge,
    createStyles,
    Center,
    Button,
    ActionIcon
} from '@mantine/core';
import {
    IconGavel,
    IconHourglass,
    IconHeartPlus,
    IconHeart,
    IconEye,
    IconBell,
    IconMovie,
    IconPhoto,
    IconAlarm,
    IconCalendar,
    IconUsers,
    IconMapPin,
    IconMessage
} from '@tabler/icons';
import { ResponsiveCarouselCard } from './ResponsiveCarouselCard';
import pagani from '../assets/pagani.jpg'
const useStyles = createStyles((theme) => ({
    cardContain: {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,    
        width: '85%'
    },

    imageSection: {
        padding: theme.spacing.md,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        /*borderBottom: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,*/
    },
    
    label: {
        marginBottom: theme.spacing.xs,
        lineHeight: 1,
        fontWeight: 700,
        fontSize: theme.fontSizes.xs,
        letterSpacing: -0.25,
        textTransform: 'uppercase',
    },
    section: {
        padding: theme.spacing.md,
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,
    },
    subSection: {
        borderBottom: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,
    },
    icon: {
        marginRight: 5,
        color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[5],
    },
    defWidth: {
        width: '60%'
    },
    timeLeftWidth: {
        width: '80%',
        marginLeft: '3%',
        margin: '0 auto'
    },
    
}));



//of_note: may want to make this into CarCreationPreview
export function CarCardDetsScoreCard() {
  const { classes } = useStyles();
  //needed:'Group's below should be mapped up here from an array

    return (
        <>
            <Card shadow="sm" p="lg" radius="md" withBorder className={classes.cardContain}>
                <Card.Section>
                    <h1>$95,000</h1>
                </Card.Section>
                <Card.Section>
                    <Group position="center" className={classes.timeLeftWidth}>
                        <h3>Time Left</h3>
                        <Group>
                            <ActionIcon variant="transparent" size="lg">
                                <IconAlarm color={"black"} size={22} stroke={2.0}/>
                            </ActionIcon>
                            <Text fw={500}>
                            4 days
                            </Text>
                        </Group>
                    </Group>
                    <Group position="apart" className={classes.timeLeftWidth}>
                        <h3>Ending</h3>
                        <Group>
                            <ActionIcon variant="transparent" size="lg">
                                <IconCalendar color={"black"} size={22} stroke={2.0}/>
                            </ActionIcon>
                            <Text fw={500}>
                            Tue, Jan 03
                            </Text>
                        </Group>
                        <br/>
                        <Text fw={500}>
                            1:30PM (PST)
                        </Text>
                    </Group>
                    <Group position="apart" className={classes.timeLeftWidth}>
                        <h3>Bids</h3>
                        <Group>
                            <ActionIcon variant="transparent" size="lg">
                                <IconUsers color={"black"} size={22} stroke={2.0}/>
                            </ActionIcon>
                            <Text fw={500}>
                            15
                            </Text>
                        </Group>
                    </Group>
                    <Group position="apart" className={classes.timeLeftWidth}>
                        <h3>Views</h3>
                        <Group>
                            <ActionIcon variant="transparent" size="lg">
                                <IconEye color={"black"} size={22} stroke={2.0}/>
                            </ActionIcon>
                            <Text fw={500}>
                            125
                            </Text>
                        </Group>
                    </Group>
                    <Group position="apart" className={classes.timeLeftWidth}>
                        <h3>Location</h3>
                        <Group>
                            <ActionIcon variant="transparent" size="lg">
                                <IconMapPin color={"black"} size={20} stroke={2.0}/>
                            </ActionIcon>
                            <Text fw={500}>
                            Pitt., PA
                            </Text>
                        </Group>
                    </Group>
                    <Group position="apart" className={classes.timeLeftWidth}>
                        <h3>Comments</h3>
                        <Group>
                            <ActionIcon variant="transparent" size="lg">
                                <IconMessage color={"black"} size={20} stroke={2.0}/>
                            </ActionIcon>
                            <Text fw={500}>
                            150
                            </Text>
                        </Group>
                    </Group>
                </Card.Section>
            </Card>
        </>
    );
}
